module.exports = __webpack_public_path__ + "img/tour-41.74260b29.png";